/** Quota de stockage exports par utilisateur (ou appareil si non connecté). */
export const EXPORT_STORAGE_LIMIT_BYTES = 1024 * 1024; // 1 Mo

export const EXPORTS_FOLDER = 'exports';

export interface UserExportRecord {
  id: string;
  name: string;
  fileType: string;
  sizeBytes: number;
  createdAt: string;
  /** Chemin relatif Supabase (exports/…) ou id local IndexedDB */
  storageKey: string;
  sourceTool?: string;
  isLocal: boolean;
}

export interface SaveUserExportParams {
  blob: Blob;
  fileName: string;
  fileType: string;
  sourceTool?: string;
}

export interface SaveUserExportResult {
  ok: boolean;
  error?: string;
  record?: UserExportRecord;
}
